export enum InvitationType {
  ORGANIZATION = "organization",
  SUPER_ADMIN = "super_admin",
  // Future invitation types can be added here
  // BRAND = "brand",
  // OPERATOR = "operator",
}

export interface BaseInvitation {
  id: string;
  email: string;
  status: string;
  expiresAt: Date;
  inviterId: string;
}

export interface OrganizationInvitation extends BaseInvitation {
  type: InvitationType.ORGANIZATION;
  organizationId: string;
  role?: string;
}

export interface SuperAdminInvitation extends BaseInvitation {
  type: InvitationType.SUPER_ADMIN;
}

export type Invitation = OrganizationInvitation | SuperAdminInvitation;

export interface InvitationContext {
  invitation: Invitation | null;
  inviterName?: string | null;
  inviterEmail?: string | null;
  organization?: { id: string; name: string; slug: string } | null;
  error?: "invalid" | "expired" | "already_processed" | null;
}

export interface InvitationAcceptanceResult {
  success: boolean;
  redirectTo: string;
  message: string;
}
